import { useEffect, useState } from 'react';

import InterviewWarningBanner from '@/features/kiosk/components/InterviewWarningBanner';
import { labAuthHealth } from '@/services/lab';

import WSReconnecting from '../components/WSReconnecting';
import { INTERVIEW_STEPS, useInterviewFlowContext } from '../contexts/interview-flow.context';
import InterviewConversationScreen from './InterviewConversationScreen';
import InterviewIntroScreen from './InterviewIntroScreen';
import InterviewPhotoScreen from './InterviewPhotoScreen';
import InterviewSummaryScreen from './InterviewSummaryScreen';

interface Props {
  onCancel: (step: INTERVIEW_STEPS) => void;
}

export default function InterviewScreen({ onCancel }: Props) {
  const { step, startInterview, goToSummary } = useInterviewFlowContext();
  const [pictureBase64, setPictureBase64] = useState<string | null>(null);

  // Single auth health check at mount (right after OTP in kiosk flow)
  useEffect(() => {
    void labAuthHealth();
  }, []);

  const handleValidatePhoto = (imageBase64: string | null) => {
    setPictureBase64(imageBase64);
    goToSummary();
  };

  const handleCancel = () => {
    onCancel(step);
  };

  const handleStart = () => {
    startInterview();
  };

  switch (step) {
    case INTERVIEW_STEPS.INTRO:
      return <InterviewIntroScreen onStart={handleStart} onCancel={handleCancel} />;
    case INTERVIEW_STEPS.INTERVIEW:
      return (
        <>
          <WSReconnecting />
          <InterviewConversationScreen onCancel={handleCancel} />
          <InterviewWarningBanner />
        </>
      );
    case INTERVIEW_STEPS.PHOTO:
      return (
        <InterviewPhotoScreen
          onValidate={handleValidatePhoto}
          onSkip={goToSummary}
          onCancel={handleCancel}
        />
      );
    case INTERVIEW_STEPS.SUMMARY:
      return <InterviewSummaryScreen onCancel={handleCancel} defaultCV={{ pictureBase64 }} />;
    default:
      return null;
  }
}
